import { FunctionComponent, memo } from "react";

interface IProps {
	width?: string;
	height?: string;
}

const ColorfulLoading: FunctionComponent<IProps> = (props) => {
	const { width = "100px", height = "100px" } = props;

	return <svg version="1.1" id="L7" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 104 104" enableBackground="new 0 0 100 100" xmlSpace="preserve" width={width} height={height}>
		<path fill="transparent" style={{ stroke: "var(--colorful-loading-blue-shadow)" }} strokeWidth="4" strokeLinecap="round" d="M 99.6373 59.7653 A 46 46 0 1 1 68.2148 10.2514">
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="2.5s"
				from="0 54 54"
				to="360 54 54"
				repeatCount="indefinite" />
		</path>
		<path fill="transparent" style={{ stroke: "var(--colorful-loading-yellow-shadow)" }} strokeWidth="8" strokeLinecap="round" d="M 76.9236 85.5517 A 39 39 0 1 0 16.9088 66.0517">
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="2.5s"
				from="0 54 54"
				to="-360 54 54"
				repeatCount="indefinite" />
		</path>
		<path fill="transparent" style={{ stroke: "var(--colorful-loading-pink-shadow)" }} strokeWidth="2" strokeLinecap="round" d="M 87 54 A 33 33 0 1 0 54 87">
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="4s"
				from="0 54 54"
				to="360 54 54"
				repeatCount="indefinite" />
		</path>
		<path fill="transparent" style={{ stroke: "var(--colorful-loading-green-shadow)" }} strokeWidth="4" strokeLinecap="round" d="M 82.7713 57.6347 A 29 29 0 1 1 62.9615 26.4194">
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="3s"
				from="0 54 54"
				to="360 54 54"
				repeatCount="indefinite" />
		</path>

		<g fillOpacity={0}>
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="2.5s"
				from="0 50 50"
				to="360 50 50"
				repeatCount="indefinite" />

			<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="5" strokeLinecap="round" d="M 95.6373 55.7653 A 46 46 0 1 1 64.2148 6.2514" />
			<path fill="transparent" style={{ stroke: "var(--colorful-loading-blue)" }} strokeWidth="4" strokeLinecap="round" d="M 95.6373 55.7653 A 46 46 0 1 1 64.2148 6.2514" />
		</g>
		<g fillOpacity={0}>
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="2.5s"
				from="0 50 50"
				to="-360 50 50"
				repeatCount="indefinite" />

			<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="9" strokeLinecap="round" d="M 72.9236 81.5517 A 39 39 0 1 0 12.9088 62.0517" />
			<path fill="transparent" style={{ stroke: "var(--colorful-loading-yellow)" }} strokeWidth="8" strokeLinecap="round" d="M 72.9236 81.5517 A 39 39 0 1 0 12.9088 62.0517" />
		</g>
		<g fillOpacity={0}>
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="4s"
				from="0 50 50"
				to="360 50 50"
				repeatCount="indefinite" />

			<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="3" strokeLinecap="round" d="M 83 50 A 33 33 0 1 0 50 83" />
			<path fill="transparent" style={{ stroke: "var(--colorful-loading-pink)" }} strokeWidth="2" strokeLinecap="round" d="M 83 50 A 33 33 0 1 0 50 83" />
		</g>
		<g fillOpacity={0}>
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				dur="3s"
				from="0 50 50"
				to="360 50 50"
				repeatCount="indefinite" />

			<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="5" strokeLinecap="round" d="M 78.7713 53.6347 A 29 29 0 1 1 58.9615 22.4194" />
			<path fill="transparent" style={{ stroke: "var(--colorful-loading-green)" }} strokeWidth="4" strokeLinecap="round" d="M 78.7713 53.6347 A 29 29 0 1 1 58.9615 22.4194" />
		</g>
	</svg>;

	// return <svg version="1.1" id="L7" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	// 	viewBox="0 0 104 104" enableBackground="new 0 0 100 100" xmlSpace="preserve" width={width} height={height}>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="5" strokeLinecap="round" d="M 95.6373 55.7653 A 46 46 0 1 1 64.2148 6.2514">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="2.5s"
	// 			from="0 50 50"
	// 			to="360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="9" strokeLinecap="round" d="M 72.9236 81.5517 A 39 39 0 1 0 12.9088 62.0517">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="2.5s"
	// 			from="0 50 50"
	// 			to="-360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="3" strokeLinecap="round" d="M 83 50 A 33 33 0 1 0 50 83">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="4s"
	// 			from="0 50 50"
	// 			to="360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-outline-color)" }} strokeWidth="5" strokeLinecap="round" d="M 78.7713 53.6347 A 29 29 0 1 1 58.9615 22.4194">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="3s"
	// 			from="0 50 50"
	// 			to="360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>

	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-blue-shadow)" }} strokeWidth="4" strokeLinecap="round" d="M 99.6373 59.7653 A 46 46 0 1 1 68.2148 10.2514">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="2.5s"
	// 			from="0 54 54"
	// 			to="360 54 54"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-yellow-shadow)" }} strokeWidth="8" strokeLinecap="round" d="M 76.9236 85.5517 A 39 39 0 1 0 16.9088 66.0517">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="2.5s"
	// 			from="0 54 54"
	// 			to="-360 54 54"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-pink-shadow)" }} strokeWidth="2" strokeLinecap="round" d="M 87 54 A 33 33 0 1 0 54 87">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="4s"
	// 			from="0 54 54"
	// 			to="360 54 54"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-green-shadow)" }} strokeWidth="4" strokeLinecap="round" d="M 82.7713 57.6347 A 29 29 0 1 1 62.9615 26.4194">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="3s"
	// 			from="0 54 54"
	// 			to="360 54 54"
	// 			repeatCount="indefinite" />
	// 	</path>

	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-blue)" }} strokeWidth="4" strokeLinecap="round" d="M 95.6373 55.7653 A 46 46 0 1 1 64.2148 6.2514">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="2.5s"
	// 			from="0 50 50"
	// 			to="360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-yellow)" }} strokeWidth="8" strokeLinecap="round" d="M 72.9236 81.5517 A 39 39 0 1 0 12.9088 62.0517">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="2.5s"
	// 			from="0 50 50"
	// 			to="-360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-pink)" }} strokeWidth="2" strokeLinecap="round" d="M 83 50 A 33 33 0 1 0 50 83">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="4s"
	// 			from="0 50 50"
	// 			to="360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>
	// 	<path fill="transparent" style={{ stroke: "var(--colorful-loading-green)" }} strokeWidth="4" strokeLinecap="round" d="M 78.7713 53.6347 A 29 29 0 1 1 58.9615 22.4194">
	// 		<animateTransform
	// 			attributeName="transform"
	// 			attributeType="XML"
	// 			type="rotate"
	// 			dur="3s"
	// 			from="0 50 50"
	// 			to="360 50 50"
	// 			repeatCount="indefinite" />
	// 	</path>
	// </svg>;
}

export default memo(ColorfulLoading);